// ローカルプレビューで確認した登録フローのタイムライン（ms）。
export const PLANNER_MOTION = {
  reveal: 800,
  introReveal: 600,
  card: 400,
  graph: 700,
  graphDraw: 850,
  graphDuration: 850,
  score: 1900,
  scoreDuration: 650,
  tags: 2800,
  tagStagger: 90,
  next: 4200,
  greeting: 450,
  definition: 1200,
  certifiedCondition: 1450,
  certifiedConditionStagger: 500,
  certifiedConditionDuration: 400,
  certifiedNext: 3000,
  recommended: 750,
  featured: 1500,
  scrollReveal: 900,
};

export const PLANNER_EASING = "cubic-bezier(0.22, 1, 0.36, 1)";
